import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import MatchingOfferModal from '@components/common/modals/MatchingOfferModal';
import PreferenceModal from '@components/match/profile/matchProposal/PreferenceModal';
import useModals from '@utils/hooks/useModals';

const MatchDashboardModals = () => {
  const { openModal, closeModal, isVisible } = useModals(['BENEFITS', 'PREFER'] as const);
  const { query } = useRouter();

  useEffect(() => {
    query.matchConfigStatus === 'true' && openModal('BENEFITS');
  }, [query]);

  const handleClose = () => {
    closeModal();
  };

  return (
    <>
      <MatchingOfferModal
        visible={isVisible('BENEFITS')}
        onClose={handleClose}
        openPreferModal={() => openModal('PREFER')}
      />
      <PreferenceModal visible={isVisible('PREFER')} onClose={handleClose} />
    </>
  );
};

export default MatchDashboardModals;
